import * as React from "react";

import StaticAssets from "@pollyslack/assets/src/StaticAssets";
import MenuBar from "src/components/MenuBar";
import { SignedInContext } from "src/SignedInContext";

export class App extends React.Component<any, any> {
  render() {
    return (
      <SignedInContext.Consumer>
        {({ signedIn }) => (
          <div className="container-fluid" style={{ height: "100vh" }}>
            <div className="d-flex flex-column align-content-stretch h-100">
              <div className="row">
                <div className="col p-0">
                  <MenuBar />
                </div>
              </div>
              <div className="row flex-grow-1 align-items-center">
                {signedIn ? (
                  <img
                    className="mx-auto"
                    src={StaticAssets.START_TRIAL_ANIMATION}
                    alt=""
                  />
                ) : (
                  <a
                    href="/auth/google"
                    style={{ cursor: "pointer" }}
                    className="mx-auto"
                  >
                    <img
                      src={StaticAssets.START_TRIAL_ANIMATION}
                      alt=""
                      style={{ display: "block" }}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </SignedInContext.Consumer>
    );
  }
}
